import React from "react"
import Button from "../../button/Button"

import { graphql } from "gatsby"
import { IFullCommercialProps } from "../gridLayout2/FullWidthPromoModules"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const FullFeature: React.FC<IFullCommercialProps> = ({
  subHeadline,
  logos,
  headline,
  button,
  backgroundImage,
}) => {
  const gatsbyImageBg =
    backgroundImage?.gatsbyImage && getImage(backgroundImage?.gatsbyImage)

  return (
    <div className="relative mx-auto flex min-h-[517px] max-w-7xl flex-col justify-between bg-cover bg-bottom bg-no-repeat pt-20 text-white">
      <div className="absolute top-0 left-0 h-full w-full">
        {gatsbyImageBg && (
          <GatsbyImage
            loading="eager"
            image={gatsbyImageBg}
            alt={backgroundImage.altText}
            className="absolute top-0 left-0 h-full w-full object-cover object-bottom"
          />
        )}

        {/* <div className="absolute left-0 top-0 h-full w-full	bg-[#2D3743] bg-opacity-85 mix-blend-multiply" /> */}
      </div>
      <div className="relative z-10 flex flex-col items-center  pb-[84px] text-center">
        <h1 className="mb-2">{headline}</h1>
        <p className="mt-0.5 mb-[50px] max-w-[307px] text-body1">
          {subHeadline}
        </p>
        <div className="flex max-w-[950px] flex-row flex-wrap items-center justify-center">
          {logos?.map((logo, index) => {
            const logoImage =
              logo?.logoIcon && getImage(logo?.logoIcon?.gatsbyImage)
            if (!logoImage) {
              return null
            }
            return (
              <GatsbyImage
                key={index}
                image={logoImage}
                alt={logoImage.logoIcon?.altText || ""}
                loading="eager"
                className="mx-[50px] mb-[50px] h-full max-w-[130px]"
              />
            )
          })}
        </div>
        {button?.title && (
          <Button
            to={button?.url}
            className="mt-7 h-[40px] px-[30px] py-1 pt-[5px]"
          >
            {button.title}
          </Button>
        )}
      </div>
    </div>
  )
}

export default FullFeature

export const fragment = graphql`
  fragment FullCommercial on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout2 {
    fieldGroupName
    blocks {
      ... on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout2_Blocks_Commercial {
        fieldGroupName
        backgroundImage {
          gatsbyImage(width: 1226, height: 517, formats: [AUTO, WEBP])
        }
        subHeadline
        headline
        logos {
          logoIcon {
            gatsbyImage(
              width: 180
              height: 50
              fit: OUTSIDE
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        button {
          target
          title
          url
        }
      }
    }
  }
`
